import { ReactNode, ElementType } from "react";
import { twMerge } from "tailwind-merge";
import { ContentFrameBase } from "@core/ui";

export type Props = {
  /** Element type to render */
  as?: ElementType;
  /** Content to render */
  children: ReactNode;
  /** Additional CSS classes for outer container */
  className?: string;
  /** Additional CSS classes for inner container */
  innerClassName?: string;
  /** ID attribute */
  id?: string;
};

/**
 * Styled full-width content container wrapping ContentFrameBase.
 * Provides centered inner content with max-width constraints.
 */
export function OuterContentContainer({
  as,
  children,
  className,
  innerClassName,
  id,
}: Props) {
  return (
    <ContentFrameBase
      as={as}
      className={twMerge("flex flex-col items-start w-full md:py-8", className)}
      innerClassName={twMerge(
        "flex flex-col max-w-7xl w-full px-4 md:px-8 items-start mx-auto",
        innerClassName
      )}
      id={id}
      data-testid="outer-content-container"
    >
      {children}
    </ContentFrameBase>
  );
}

export default OuterContentContainer;
